import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import EraChat from "@/components/EraChat";

export const Layout = ({ children }) => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const previous = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";
    return () => { window.history.scrollRestoration = previous; };
  }, []);

  useEffect(() => {
    if (!hash) window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return (
    <div className="relative min-h-screen bg-white">
      <div className="relative z-10">
        <Header />
        <main className={pathname === "/" ? "pt-[84px] sm:pt-24" : "pt-16 sm:pt-[72px]"}>{children}</main>
        <Footer />
      </div>
      <EraChat />
    </div>
  );
};

export default Layout;
